import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../../../dto/data-model.js';
import { AuditLogEntry } from '../../audit-log-entry.js';
import { EventTicketOrder } from '../../../event-ticket-order.js';
import { MapUtils } from '../../../../../utility/map-utils.js';
import {
  cloneData, isSameData,
} from '../../../../dto/data-model-utils.js';
import { AuditLogEntryType } from '../../audit-log-entry-type.js';

export class OfflineEventTicketOrderCompletedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'bc0a2f219f244a42a04df0300df3990a';

  private constructor(
    public readonly before: EventTicketOrder,
    public readonly after: EventTicketOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return OfflineEventTicketOrderCompletedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OfflineEventTicketOrderCompleted;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      eventId: this.after.eventId,
      orderId: this.after.uniqueId,
    };
  }

  static create(args: {
    before: EventTicketOrder,
    after: EventTicketOrder,
  }): OfflineEventTicketOrderCompletedEntry {
    return new OfflineEventTicketOrderCompletedEntry(
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OfflineEventTicketOrderCompletedEntry {
    return this.create({
      before: context.fromData(MapUtils.getRecord(map, 'before')),
      after: context.fromData(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return OfflineEventTicketOrderCompletedEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
           isSameData(other.after, this.after);
  }
}

export class OfflineEventTicketOrderCompletedEntryBuilder extends DataModelBuilder<OfflineEventTicketOrderCompletedEntry> {
  build(context: SerializationContext, map: SerializedData): OfflineEventTicketOrderCompletedEntry {
    return OfflineEventTicketOrderCompletedEntry.fromMap(context, map);
  }
}
